import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
  useHistory,
} from 'react-router-dom'
import Cookies from 'js-cookie'
import config from '../config'
import Edit from './Edit'
import List from './List'
import Container from './Container'
import Images from './Images'

const Main = () => {
  
  const history = useHistory()
  const logout = () => {
    Cookies.remove('token')
    Cookies.remove('user')
    history.replace('/login')
  }
  let username = 'Anonymous'
  if (Cookies.get('user')) {
    const userData = JSON.parse(Cookies.get('user'))
    if (userData) {
      username = userData.name
    }
  }

  const isMenuItemActive = item => {
    let active = false
    if (typeof item.items !== 'undefined') {
      item.items.forEach(subitem => {
        if (!active && history.location.pathname.includes(subitem.type)) {
          active = true
        }
      })
    }
    if (!active) {
      return history.location.pathname.includes(item.type)
    }
    return active
  }

  return (
    <div className="flex flex-col min-h-screen">
      <nav className="py-12 bg-white">
        <Container className="justify-between md:flex">
          <div>
            <ul className="flex">
              {config.menu.map(item => (
                <li key={item.type} className="mr-4">
                  <NavLink className="hover:wght-semibold" activeClassName="wght-semibold" to={item.path || `/admin/list/${item.type}`}>
                    {item.title}
                  </NavLink>
                </li>
              ))}
            </ul>
            {config.menu.map(item => {
              if (isMenuItemActive(item)) {
                return (
                  <ul key={item.type} className="flex mt-4 text-xs">
                    {
                      item.items && item.items.map(subitem => (
                        <li key={subitem.type} className="mr-4">
                          <NavLink className="hover:wght-semibold" activeClassName="wght-semibold" to={subitem.path || `/admin/list/${subitem.type}`}>
                            {subitem.title}
                          </NavLink>
                        </li>
                      ))
                    }
                  </ul>
                )
              }
              return null
            })}
          </div>
          {config.deploy && <div className="hidden wght-semibold md:block">
            <a href="/admin/images" className="p-2 mr-2 text-xs text-center rounded cursor-pointer bg-orange">Deploy</a>
          </div>}
        </Container>
      </nav>
      <div className="flex-1 py-12">
        <Container>
          <Switch>
            <Route path="/admin/list/:name/:id?">
              <List />
            </Route>
            <Route path="/admin/edit/:name/:id?">
              <Edit />
            </Route>
            <Route path="/admin/images">
              <Images />
            </Route>
          </Switch>
        </Container>
      </div>
      <div className="py-12 bg-white">
        <Container>
          <div className="flex justify-between">
            <div className="text-xs">
              👋 Hi <span className="capitalize">{username}</span>. Would you like to <span onClick={logout} className="cursor-pointer wght-bold hover:wght-semibold">log out</span>?
            </div>
            <div className="text-xs">
              {config.title}
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}
export default Main
